import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { BACKEND_URL } from "../../common/Common";
import "./Navbar.css";

// Import your images
import hayatin from '../../../assets/images/hayatin.jpg';
import homeicon from '../../../assets/home-images/homeicon.jpg';
import experienceicon from '../../../assets/home-images/experienceicon.jpg';
import businessicon from '../../../assets/home-images/businessicon.jpg';
import eventsicon from '../../../assets/home-images/eventsicon.jpg';
import homeunselect from '../../../assets/home-images/homeunselect.png';
import experienceselect from '../../../assets/home-images/experienceselect.png';
import businessiconselect from '../../../assets/home-images/businessiconselect.png';
import videos from '../../../assets/home-images/videos.png';
import downarrow from '../../../assets/home-images/downarrow.png';
import app_store from '../../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../../assets/home-images/right-section-images/play_store.png';
import xmark from '../../../assets/home-images/right-section-images/xmark.png';
import mobiletoggle from '../../../assets/home-images/mobiletoggle.png';
import flagicon from '../../../assets/home-images/flagicon.png';
import canadaflag from '../../../assets/experience/canadaflag.png';
import omanflag from '../../../assets/experience/omanflag.png';
import qatarflag from '../../../assets/experience/qatarflag.png';
import kuwaitflag from '../../../assets/experience/kuwaitflag.png';
import ksaflag from '../../../assets/experience/ksaflag.png';
import eventselecticon from '../../../assets/home-images/eventselecticon.png';

//PROFILE ICON AFTER REGISTERED
import plusicon from '../../../assets/home-images/plusicon.png';
import messageicon from '../../../assets/home-images/messageicon.png';
import bellicon from '../../../assets/home-images/bellicon.png';
import profileicon from '../../../assets/home-images/profileicon.png';

const countryicons = [canadaflag, omanflag, qatarflag, kuwaitflag, ksaflag];

// Hamburger menu icon - using SVG for simplicity
const HamburgerIcon = () => (
    <img src={mobiletoggle} alt="menu toggle" className="mobile-toggle-icon" />
);

// Close icon (X)
const CloseIcon = () => (
    <img src={xmark} alt="xmark" className="close-popup" />
);

const Navbar = ({
    selectedState = null,
    onStateChange = null,
    states = [],
    showLocationSelector = false
}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [countrypopup, setCountrypopup] = useState(false);
    const [logoutPopup, setLogoutPopup] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, right: 0 });
    const profileRef = useRef(null);
    const location = useLocation();
    const [userData, setUserData] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    // Check if user is logged in and get user data
    useEffect(() => {
        const checkUserLogin = () => {
            const userId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
            const userStr = localStorage.getItem('user');

            console.log("Navbar checking login status:", { userId, hasUserStr: !!userStr });

            if (userId && userStr) {
                try {
                    const user = JSON.parse(userStr);
                    console.log("Navbar parsed user data:", user);
                    setUserData(user);
                    setIsLoggedIn(true);
                } catch (error) {
                    console.error("Error parsing user data:", error);
                    setIsLoggedIn(false);
                }
            } else {
                setIsLoggedIn(false);
                setUserData(null);
            }
        };

        // Check immediately
        checkUserLogin();

        // Listen for custom event when user login state changes
        const handleUserLoginStateChange = () => {
            console.log("Navbar received userLoginStateChanged event");
            checkUserLogin();
        };

        window.addEventListener('userLoginStateChanged', handleUserLoginStateChange);

        // Listen for storage changes (in case data is stored from another tab/window)
        const handleStorageChange = (e) => {
            if (e.key === 'user_id' || e.key === 'user') {
                checkUserLogin();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('userLoginStateChanged', handleUserLoginStateChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [location.pathname]); // Re-check on route change

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const closeMenuCountrypopupOpen = () => {
        setMenuOpen(false);
        setCountrypopup(true)
    };

    // Routes that can belong to multiple sections (ambiguous routes)
    const ambiguousRoutes = [
        "/offers",
        "/categorylist",
        "/banners",
        "/spotlights",
        "/unlimitedoffers",
        "/vendordetails",
        "/nearyou"
    ];

    // Determine which section the current route belongs to
    const getActiveSection = () => {
        const pathname = location.pathname;

        // Check if it's experience section (routes starting with /experience)
        if (pathname.startsWith("/experience")) {
            // Store in sessionStorage for ambiguous routes
            sessionStorage.setItem("activeSection", "experience");
            return "experience";
        }

        // Check if it's business section (routes starting with /business-and-brands)
        if (pathname.startsWith("/business-and-brands")) {
            // Store in sessionStorage for ambiguous routes
            sessionStorage.setItem("activeSection", "business");
            return "business";
        }

        // Check if it's events section (routes starting with /events or /eventdetails)
        if (pathname.startsWith("/events") || pathname.startsWith("/eventdetails") || pathname.startsWith("/eventcategorylist")) {
            // Store in sessionStorage for ambiguous routes
            sessionStorage.setItem("activeSection", "events");
            return "events";
        }

        // Check if it's explicitly home route
        if (pathname === "/") {
            // Store in sessionStorage for ambiguous routes
            sessionStorage.setItem("activeSection", "home");
            return "home";
        }

        // For videoposts route, check sessionStorage to see which section was last visited
        if (pathname.startsWith("/videoposts")) {
            const lastSection = sessionStorage.getItem("activeSection");
            // If we have a stored section and it's valid, use it
            if (lastSection === "experience" || lastSection === "business" || lastSection === "events" || lastSection === "home") {
                return lastSection;
            }
        }

        // For searchpage route, check sessionStorage to see which section was last visited
        if (pathname.startsWith("/searchpage")) {
            const lastSection = sessionStorage.getItem("activeSection");
            // If we have a stored section and it's valid, use it
            if (lastSection === "experience" || lastSection === "business" || lastSection === "events" || lastSection === "home") {
                return lastSection;
            }
        }

        // For ambiguous routes, check sessionStorage to see which section was last visited
        const isAmbiguousRoute = ambiguousRoutes.some(route => pathname.startsWith(route));
        if (isAmbiguousRoute) {
            const lastSection = sessionStorage.getItem("activeSection");
            // If we have a stored section and it's valid, use it
            if (lastSection === "experience" || lastSection === "business" || lastSection === "events" || lastSection === "home") {
                return lastSection;
            }
        }

        // Default to home section for other routes
        return "home";
    };

    const activeSection = getActiveSection();

    // Icon active states based on active section
    const isHomeIconActive = activeSection === "home";
    const isExperienceIconActive = activeSection === "experience";
    const isBusinessIconActive = activeSection === "business";
    const isEventsIconActive = activeSection === "events";

    // Helper function to get flag icon based on selected state
    const getFlagIcon = (state) => {
        if (!state) return flagicon;

        // Toronto (id === 9) uses Canada flag
        if (state.id === 9) return countryicons[0]; // Canada
        // Abu Dhabi (id === 1) and Dubai (id === 2) use default flagicon
        if (state.id === 1 || state.id === 2) return flagicon;
        // Oman (id === 5)
        if (state.id === 5) return countryicons[1]; // Oman
        // Qatar (id === 6)
        if (state.id === 6) return countryicons[2]; // Qatar
        // Kuwait (id === 7)
        if (state.id === 7) return countryicons[3]; // Kuwait
        // KSA (id === 8)
        if (state.id === 8) return countryicons[4]; // KSA

        // Default to flagicon for any other state
        return flagicon;
    };

    const handleStateClick = (state) => {
        if (onStateChange) {
            onStateChange(state);
        }
        setCountrypopup(false);
        closeMenu(); // Close sidebar after selecting location
    };

    const handleProfileClick = () => {
        if (profileRef.current) {
            const rect = profileRef.current.getBoundingClientRect();
            // Position popup below the profile, aligned to the right edge
            setPopupPosition({
                top: rect.bottom + 8,
                right: window.innerWidth - rect.right
            });
        } else {
            // Fallback position if ref is not available
            setPopupPosition({
                top: 78,
                right: 80
            });
        }
        setLogoutPopup(true);
    };

    const handleLogout = async () => {
        // Close popup immediately
        setLogoutPopup(false);
        
        const authToken = localStorage.getItem('token') || sessionStorage.getItem('token');
        
        if (!authToken) {
            // If no token, just clear storage and update state
            handleLogoutComplete();
            return;
        }

        setIsLoggingOut(true);
        try {
            const payload = {
                auth_token: authToken
            };
            
            console.log("Logout Payload:", payload);
            console.log("Logout API URL:", `${BACKEND_URL}website/logout`);
            
            const response = await axios.post(`${BACKEND_URL}website/logout`, payload);
            
            console.log("Logout Response:", response.data);
            console.log("Logout Response Status:", response.status);
            
            // Logout successful
            handleLogoutComplete();
        } catch (error) {
            console.error("Error during logout:", error);
            if (error.response) {
                console.error("Logout Error Response:", error.response.data);
                console.error("Logout Error Status:", error.response.status);
            } else if (error.request) {
                console.error("Logout Error Request:", error.request);
            }
            // Even if API call fails, clear local storage and update state
            handleLogoutComplete();
        } finally {
            setIsLoggingOut(false);
        }
    };

    const handleLogoutComplete = () => {
        // Clear all authentication data
        localStorage.removeItem('user_id');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('user_id');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        
        // Update local state
        setIsLoggedIn(false);
        setUserData(null);
        
        // Dispatch event to notify other components (like Home.js)
        window.dispatchEvent(new Event('userLoginStateChanged'));
    };

    const handleLogoutCancel = () => {
        setLogoutPopup(false);
    };

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (logoutPopup) {
                const popupElement = document.querySelector('.logout-popup');
                const isClickOnProfile = profileRef.current && profileRef.current.contains(event.target);
                const isClickOnPopup = popupElement && popupElement.contains(event.target);
                
                if (!isClickOnProfile && !isClickOnPopup) {
                    setLogoutPopup(false);
                }
            }
        };

        if (logoutPopup) {
            // Use a small delay to avoid closing immediately when opening
            setTimeout(() => {
                document.addEventListener('mousedown', handleClickOutside);
            }, 100);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [logoutPopup]);

    // Handler to set flag when navigating from navbar
    const handleNavbarNavigation = () => {
        sessionStorage.setItem('navigatedFromNavbarOrLeftSection', 'true');
        closeMenu();
    };

    // Prevent body scroll when sidebar is open
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [menuOpen]);

    return (
        <>
            <nav className="navbar">
                <div className="navbar-brand">
                    <a href="/">
                        <img src={hayatin} alt="hayatin" />
                    </a>
                </div>

                {/* Desktop Navigation Icons */}
                <div className="homepage-icons desktop-nav">
                    <NavLink
                        to="/"
                        end
                        onClick={handleNavbarNavigation}
                        className={isHomeIconActive ? "active" : ""}
                    >
                        <img
                            src={isHomeIconActive ? homeicon : homeunselect}
                            alt="home"
                        />
                        <span className="nav-tooltip">Home</span>
                    </NavLink>

                    <NavLink
                        to="/experience"
                        onClick={() => {
                            // Set flag when navigating away from home
                            if (activeSection === "home") {
                                sessionStorage.setItem('wasOnOtherPage', 'true');
                            }
                            closeMenu();
                        }}
                        className={isExperienceIconActive ? "active" : ""}
                    >
                        <img
                            src={isExperienceIconActive ? experienceselect : experienceicon}
                            alt="experience"
                        />
                        <span className="nav-tooltip">Experience</span>
                    </NavLink>
                    <NavLink
                        to="/events"
                        onClick={() => {
                            // Set flag when navigating away from home
                            if (activeSection === "home") {
                                sessionStorage.setItem('wasOnOtherPage', 'true');
                            }
                            closeMenu();
                        }}
                        className={isEventsIconActive ? "active" : ""}
                    >
                        <img
                            src={isEventsIconActive ? eventselecticon : eventsicon}
                            alt="events"
                        />
                        <span className="nav-tooltip">Events</span>
                    </NavLink>


                    <NavLink
                        to="/business-and-brands"
                        onClick={() => {
                            // Set flag when navigating away from home
                            if (activeSection === "home") {
                                sessionStorage.setItem('wasOnOtherPage', 'true');
                            }
                            closeMenu();
                        }}
                        className={isBusinessIconActive ? "active" : ""}
                    >
                        <img
                            src={isBusinessIconActive ? businessiconselect : businessicon}
                            alt="business"
                        />
                        <span className="nav-tooltip">Businesses</span>
                    </NavLink>
                </div>

                {/* Desktop Register Button */}
                <div className="registerbtn-icons desktop-register">
                    <div className="register-business">
                        <a href="https://www.hayatinapp.com/vendor/register">
                            <button className="register-business-btn">
                                Register Your Business
                            </button>
                        </a>
                    </div>

                    {isLoggedIn && (
                        <div className="notificationicons" ref={profileRef}>
                            {/* <img src={plusicon} alt="plusicon" onClick={() => setPostpopup(true)} /> */}
                            {/* <img src={messageicon} alt="messageicon" /> */}
                            {/* <img src={bellicon} alt="bellicon" /> */}
                            {(userData?.profile_image && userData.profile_image.trim() !== '') ||
                                (userData?.user_image && userData.user_image.trim() !== '') ? (
                                <img
                                    src={userData.profile_image || userData.user_image}
                                    alt={userData.name || userData.user_name || "profile"}
                                    className="navbar-profile-image"
                                    onClick={handleProfileClick}
                                />
                            ) : (
                                <div className="navbar-profile-initial" onClick={handleProfileClick}>
                                    {(userData?.name || userData?.user_name)
                                        ? (userData.name || userData.user_name).charAt(0).toUpperCase()
                                        : '?'}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Mobile Hamburger Menu Button */}
                <button
                    className="hamburger-menu-btn mobile-only"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <HamburgerIcon />
                </button>
            </nav>

            {/* Mobile Sidebar Overlay */}
            {menuOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={closeMenu}
                ></div>
            )}

            {/* Mobile Sidebar */}
            <aside className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
                <div className="sidebar-header">
                    <button
                        className="close-sidebar-btn"
                        onClick={closeMenu}
                        aria-label="Close menu"
                    >
                        <CloseIcon />
                    </button>
                </div>

                <div className="sidebar-menu-content">
                    {/* Navigation Links */}
                    <NavLink
                        to="/"
                        end
                        className={`sidebar-menu-item ${isHomeIconActive ? 'active' : ''}`}
                        onClick={handleNavbarNavigation}
                    >
                        <>
                            <div className="sidebar-menu-icon">
                                <img
                                    src={isHomeIconActive ? homeicon : homeunselect}
                                    alt="home"
                                />
                            </div>
                            <span>Home</span>
                        </>
                    </NavLink>
                    <Link
                        to="/videoposts"
                        className="sidebar-menu-item"
                        onClick={() => {
                            sessionStorage.setItem('videopost_navigated', 'true');
                            sessionStorage.setItem('fetch_all_videos', 'true');
                            closeMenu();
                        }}
                    >
                        <div className="sidebar-menu-icon">
                            <img src={videos} alt="videos" />
                        </div>
                        <span>Videos for you</span>
                    </Link>

                    <NavLink
                        to="/experience"
                        className={`sidebar-menu-item ${isExperienceIconActive ? 'active' : ''}`}
                        onClick={() => {
                            // Set flag when navigating away from home
                            if (activeSection === "home") {
                                sessionStorage.setItem('wasOnOtherPage', 'true');
                            }
                            closeMenu();
                        }}
                    >
                        <>
                            <div className="sidebar-menu-icon">
                                <img
                                    src={isExperienceIconActive ? experienceselect : experienceicon}
                                    alt="experience"
                                />
                            </div>
                            <span>Experience</span>
                        </>
                    </NavLink>

                    <NavLink
                        to="/events"
                        className={`sidebar-menu-item ${isEventsIconActive ? 'active' : ''}`}
                        onClick={() => {
                            // Set flag when navigating away from home
                            if (activeSection === "home") {
                                sessionStorage.setItem('wasOnOtherPage', 'true');
                            }
                            closeMenu();
                        }}
                    >
                        <>
                            <div className="sidebar-menu-icon">
                                <img
                                    src={isEventsIconActive ? eventselecticon : eventsicon}
                                    alt="events"
                                />
                            </div>
                            <span>Events</span>
                        </>
                    </NavLink>

                    <NavLink
                        to="/business-and-brands"
                        className={`sidebar-menu-item ${isBusinessIconActive ? 'active' : ''}`}
                        onClick={() => {
                            // Set flag when navigating away from home
                            if (activeSection === "home") {
                                sessionStorage.setItem('wasOnOtherPage', 'true');
                            }
                            closeMenu();
                        }}
                    >
                        <>
                            <div className="sidebar-menu-icon">
                                <img
                                    src={isBusinessIconActive ? businessiconselect : businessicon}
                                    alt="business"
                                />
                            </div>
                            <span>Businesses</span>
                        </>
                    </NavLink>
                    {/* Location Selector - Only show if showLocationSelector is true */}
                    {showLocationSelector && (
                        <div
                            className="sidebar-menu-item sidebar-location-item"
                            onClick={closeMenuCountrypopupOpen}
                        >
                            <div className="sidebar-menu-icon">
                                <img src={getFlagIcon(selectedState)} alt="flag" className="flagicon" />
                            </div>
                            <span>{selectedState?.name || "Abu Dhabi"}</span>
                        </div>
                    )}
                </div>

                {/* App Download Section */}
                <div className="sidebar-download-section">
                    <h4>Download Hayat In App</h4>
                    <div className="sidebar-store-buttons">
                        <a
                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="store-button-link"
                        >
                            <img src={app_store} alt="Download on the App Store" />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="store-button-link"
                        >
                            <img src={play_store} alt="Get it on Google Play" />
                        </a>
                    </div>
                </div>

                {/* Register Business Button */}
                <div className="sidebar-register-section">
                    <a href="https://www.hayatinapp.com/vendor/register">
                        <button className="sidebar-register-btn">
                            Register Your Business
                        </button>
                    </a>
                </div>

                {/* Footer Links */}
                <div className="sidebar-footer-links">
                    <div className="sidebar-footer-row">
                        <a href="/about">About Us</a>
                        <Link to="/merchantagreement" className="sidebar-footer-link-arrow">
                            <span>Privacy & Terms</span>
                            <img src={downarrow} alt="down arrow" />
                        </Link>
                          <a href="/downloadpage">Download</a>
                          <a href="/businesspro">BusinessPro</a>
                    </div>
                </div>
            </aside>

            {/* Country popup - Only render if showLocationSelector is true */}
            {showLocationSelector && countrypopup && (
                <>
                    <div
                        className="custom-overlay"
                        onClick={() => setCountrypopup(false)}
                    ></div>

                    <div className="custom-popup">
                        <div className="custom-popup-header">
                            <h4>Choose Your Location</h4>
                            <img
                                src={xmark}
                                alt="close"
                                className="close-popup"
                                onClick={() => setCountrypopup(false)}
                            />
                        </div>

                        <div className="custom-popup-body">
                            <div className="state-grid">
                                {(() => {
                                    // Filter and sort states: Abu Dhabi, Dubai, Toronto, then others
                                    const filteredStates = states.filter((state) => Number(state.country_id));

                                    // Sort states: Abu Dhabi (1), Dubai (2), Toronto (9), then others
                                    const sortedStates = [...filteredStates].sort((a, b) => {
                                        // Abu Dhabi first
                                        if (a.id === 1) return -1;
                                        if (b.id === 1) return 1;
                                        // Dubai second
                                        if (a.id === 2) return -1;
                                        if (b.id === 2) return 1;
                                        // Toronto third (right after Dubai)
                                        if (a.id === 9) return -1;
                                        if (b.id === 9) return 1;
                                        // Rest maintain original order
                                        return a.id - b.id;
                                    });

                                    return sortedStates.map((state, index, arr) => {
                                        // Disable last 4 items, but exclude Toronto from being disabled
                                        const isToronto = state.id === 9;
                                        const isDisabled = !isToronto && index >= arr.length - 4;

                                        // Determine flag icon: Abu Dhabi, Dubai use flagicon
                                        // Others use countryicons array (Oman, Qatar, Kuwait, KSA)
                                        // Toronto uses Canada flag
                                        let flagSrc = flagicon;
                                        if (state.id === 9) flagSrc = countryicons[0]; //Canada
                                        else if (state.id === 5) flagSrc = countryicons[1]; // Oman
                                        else if (state.id === 6) flagSrc = countryicons[2]; // Qatar
                                        else if (state.id === 7) flagSrc = countryicons[3]; // Kuwait
                                        else if (state.id === 8) flagSrc = countryicons[4]; // KSA

                                        return (
                                            <div
                                                key={state.id}
                                                className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                onClick={() => !isDisabled && handleStateClick(state)}
                                            >
                                                <img
                                                    src={flagSrc}
                                                    alt="flag"
                                                    className="flagicon-popup"
                                                />
                                                <p>{state.name}</p>
                                            </div>
                                        );
                                    });
                                })()}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* Logout Confirmation Popup */}
            {logoutPopup && (
                <div 
                    className="logout-popup"
                    style={{
                        top: `${popupPosition.top}px`,
                        right: `${popupPosition.right}px`
                    }}
                >
                    <div className="logout-popup-content">
                        <p className="logout-popup-message">
                            Do you want to log out?
                        </p>
                        <div className="logout-popup-buttons">
                            <button
                                onClick={handleLogoutCancel}
                                className="logout-btn-cancel"
                                disabled={isLoggingOut}
                            >
                                No
                            </button>
                            <button
                                onClick={handleLogout}
                                className="logout-btn-confirm"
                                disabled={isLoggingOut}
                            >
                                {isLoggingOut ? 'Logging out...' : 'Yes'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Navbar;